import { Common, ApiBind } from './common.model';

export class DeliverySetIpGroup extends Common {
  @ApiBind({ column: 'ip_group_id' })
  id: number;
}
